import * as React from "react"

import { cn } from "@/lib/utils"
import { isNativeRoute } from "@/config/nativeScreens"

// A number field that cannot go negative (min ≥ 0) asks the phone for its
// number pad rather than the full keyboard — weights, rates and counts are most
// of what gets typed on the floor. A field that may be negative keeps the full
// keyboard, because iOS's decimal pad has no minus key. An explicit inputMode
// from the caller always wins.
//
// On the native floor screens (config/nativeScreens.js) on a phone, a number
// field with no `min` gets the pad too: nothing keyed there is negative, and the
// full keyboard for a weight is the commonest complaint from the floor. A field
// that genuinely takes a negative says so with a negative `min`.
const onNativePhone = () => (
  typeof window !== "undefined"
  && window.matchMedia?.("screen and (max-width: 767.98px)").matches
  && isNativeRoute(window.location.pathname)
)

const numberPad = (type, min, step, inputMode) => {
  if (inputMode !== undefined || type !== "number") return inputMode
  const noMin = min === undefined || min === null || min === ""
  if (noMin ? !onNativePhone() : Number(min) < 0) return undefined
  return step !== undefined && Number.isInteger(Number(step)) && Number(step) >= 1 ? "numeric" : "decimal"
}

const Input = React.forwardRef(({ className, type, inputMode, ...props }, ref) => {
  return (
    <input
      type={type}
      inputMode={numberPad(type, props.min, props.step, inputMode)}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
